import { Box, MenuItem, Select, Typography } from '@mui/material';
import { ReactElement } from 'react';
import { userService } from 'common/services/user.service';
import { RetailerType } from 'common/constants/entities';
import { getBTNsStyles } from './styles';
import { OptimizationStatus } from '../../constants';

interface Props {
  optimizationStatus: OptimizationStatus;
  handleChangeOptimizedStatus: (value: OptimizationStatus) => void;
}

export function ProductToggles({ optimizationStatus, handleChangeOptimizedStatus }: Props): ReactElement {
  const styles = getBTNsStyles();

  const productOptions = [
    {
      label: 'OPTIMIZED',
      value: OptimizationStatus.Regular,
      disabled: false,
    },
    {
      label: 'SEO OPTIMIZED',
      value: OptimizationStatus.SEO,
      disabled: false,
    },
    ...(userService.ensureRetailer(RetailerType.Target)
      ? [
          {
            label: 'GEO OPTIMIZED',
            value: OptimizationStatus.GEO,
            disabled: false,
          },
        ]
      : []),
  ];

  return (
    <Box sx={styles.wrapper}>
      <Typography sx={styles.toggle}>TYPE</Typography>
      <Select
        value={optimizationStatus}
        size="small"
        onChange={e => handleChangeOptimizedStatus(e.target.value as OptimizationStatus)}
        sx={{ minWidth: 200, mx: 2 }}
      >
        {productOptions.map(o => (
          <MenuItem key={o.value} value={o.value} disabled={o.disabled}>
            {o.label}
          </MenuItem>
        ))}
      </Select>
    </Box>
  );
}
